__turbopack_context__.v({
  "Buttons": "ServiceHero-module-scss-module__l7Xx8q__Buttons",
  "Image": "ServiceHero-module-scss-module__l7Xx8q__Image",
  "Intro": "ServiceHero-module-scss-module__l7Xx8q__Intro",
  "IntroWrapper": "ServiceHero-module-scss-module__l7Xx8q__IntroWrapper",
  "LogoContainer": "ServiceHero-module-scss-module__l7Xx8q__LogoContainer",
  "LogoWrapper": "ServiceHero-module-scss-module__l7Xx8q__LogoWrapper",
  "Title": "ServiceHero-module-scss-module__l7Xx8q__Title",
  "Wrapper": "ServiceHero-module-scss-module__l7Xx8q__Wrapper",
});
